import { Box, Flex, Text } from '@chakra-ui/react';
import { ReactComponent as ChatIcon } from '../../../logos/chatIcon.svg';

const SidebarItem = ({
  conversationTitle,
  conversationId,
  isActive,
  setActiveConversationId,
  setShowLoadingAnimation,
  setShowProviderLoadingScreen,
  isDisabled,
}) => {
  return (
    <Box
      key={conversationId}
      bg={isActive ? (isDisabled ? 'gray.200' : 'blue.200') : 'white'}
      h='38px'
      p={3}
      rounded='md'
      _hover={{ bg: isDisabled ? 'none' : 'blue.100' }}
      display='flex'
      alignItems='center'
      userSelect='none'
      cursor={isDisabled ? 'not-allowed' : 'pointer'}
      opacity={isDisabled ? 0.6 : 1}
      onClick={() => {
        if (!isDisabled && !isActive) {
          setActiveConversationId(conversationId);
          setShowLoadingAnimation(false);
        }
      }}
    >
      <Flex alignItems='center' w='100%'>
        <ChatIcon
          style={{
            marginRight: '12px',
            minWidth: '16px',
            opacity: isDisabled ? 0.6 : 1,
          }}
        />
        <Text
          fontSize='xs'
          whiteSpace='nowrap'
          overflow='hidden'
          textOverflow='ellipsis'
          flexGrow={1}
          color={isDisabled ? 'gray.500' : 'currentcolor'}
          opacity={isDisabled ? 0.6 : 1}
        >
          {conversationTitle}
        </Text>
      </Flex>
    </Box>
  );
};

export default SidebarItem;
